import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ResiliationConsultantService } from '../../resiliation/services/resiliation-consultant.service';

export const declarationGuard: CanActivateFn = () => {
  const resiliationService = inject(ResiliationConsultantService);
  const router = inject(Router);

  const resiliation = resiliationService.resiliation();

  if (resiliation !== null) {
    router.navigate(['/accueil']);
    return false;
  }
  return true;
};
